module.exports = __webpack_public_path__ + "media/packs/images/flags/JM-94945a126daa6c29f94273ab5242e16d.svg";